import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { searchParts } from "#modules/parts/infra/searchParts.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { FilterQuery } from "shared";

export const searchPartsQuery = (filtersParams: FilterQuery, limit = 9) => ({
  queryKey: queryKeys.parts.search(filtersParams, limit),
  queryFn: () => searchParts({ filtersParams, limit }),
  staleTime: STALE_TIME_L,
});
